import React, { useCallback, useMemo, useState } from 'react';
import { Box, InputBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import DiaLog from '../../../../../components/Dialog';
import { i18n } from '../../../../../language';
import { AutoCompleteSelect } from '../../../../../components';
import { systemAPI } from '../../../../../apis';
import { TAB_STATUS } from '../../../../../comm/constant';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'NotoSans-Medium',
    color: '#7d86a9',
    fontSize: '0.875rem',
  },
  input: {
    fontFamily: 'NotoSans-Medium',
    color: '#2e4469',
    fontSize: '1.125rem',
    border: 'solid 1px #e4e7eb',
    height: '3.5rem',
    borderRadius: '10px',
    paddingLeft: '1rem',
  },
}));

const EditWardTag = ({ handleClose, handleRefresh, data }) => {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    tagDesc: data.tagDesc,
    status: data.status,
  });

  const formHandler = useCallback(
    (type) => (event) => {
      if (type === 'status') {
        setFormData((oldData) => ({
          ...oldData,
          [type]: event,
        }));
      } else {
        setFormData((oldData) => ({
          ...oldData,
          [type]: event.target.value,
        }));
      }
    },
    []
  );
  const submitHandler = useCallback(async () => {
    try {
      await systemAPI.updateWardTag({ ...formData, tagId: data.id });

      handleRefresh();
    } catch (error) {
      console.log();
    }
  }, [formData, data.id, handleRefresh]);

  const deleteHandler = useCallback(async () => {
    try {
      await systemAPI.deleteWardTag({
        tagId: data.id,
      });

      handleRefresh();
    } catch (error) {
      console.log(error);
    }
  }, [data.id]);

  const itemList = useMemo(() => {
    return _.map(TAB_STATUS, (item, index) => ({
      value: index,
      text: item,
    }));
  }, []);

  return (
    <DiaLog
      open={true}
      title={i18n.t('SETTING_EDIT_TAG')}
      cancel={i18n.t('SETTING_REMOVE')}
      confirm={i18n.t('SETTING_UPDATE')}
      handleConfirm={submitHandler}
      handleClose={handleClose}
      handleCancel={deleteHandler}
      cancelStyle={{ border: 'unset', backgroundColor: '#ff655c', color: '#fff' }}
      confirmStyle={{ border: 'unset', backgroundColor: '#28d2ab', color: '#fff' }}
    >
      <Box display="flex" flexDirection="column" gridRowGap="0.5rem">
        <div className={classes.title}>{i18n.t('SETTING_WARD_TAG_POPUP_NAME')}*</div>
        <InputBase
          className={classes.input}
          value={formData.tagDesc}
          onChange={formHandler('tagDesc')}
          inputProps={{ maxLength: 60 }}
        />
      </Box>
      <Box display="flex" flexDirection="column" gridRowGap="0.5rem" mt="2rem">
        <div className={classes.title}>{i18n.t('SETTING_HOSPITAL_POPUP_STATUS')}</div>
        <AutoCompleteSelect itemList={itemList} value={formData.status} onChange={formHandler('status')} />
      </Box>
    </DiaLog>
  );
};

export default EditWardTag;
